import { QUERY_KEYS } from "@/libraries/constant";
import type { GetTeamsParamsSchema } from "@/schemas";
import { teamService } from "@/services";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";

export const getTeamsQueryOptions = (
	params: GetTeamsParamsSchema,
	options?: { enabled: boolean },
) =>
	infiniteQueryOptions({
		queryKey: [QUERY_KEYS.GET_TEAMS, params],
		initialPageParam: 1,
		queryFn: ({ pageParam, signal }) =>
			teamService.getTeams({ ...params, page: pageParam }, { signal }),
		getNextPageParam: (lastPage) => lastPage?.meta?.next_page,
		...options,
	});

export const getTeamQueryOptions = (id: any) =>
	queryOptions({
		queryKey: [QUERY_KEYS.GET_TEAM, id],
		queryFn: () => teamService.getTeam(id),
		enabled: !!id,
	});
